import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "../layout/DashboardLayout";
import API from "../api/axios";
import { AuthContext } from "../context/AuthContext";
import "./Profile.css";

const Profile = () => {
  const { setUser } = useContext(AuthContext);
  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      const res = await API.get("/auth/profile");
      const data = res.data.user || res.data;
      setProfile(data);
      setForm({
        name: data.name || "",
        email: data.email || "",
        companyName: data.companyName || "",
        number: data.number || "",
        address: data.address || "",
        gstNumber: data.gstNumber || "",
        accountNumber: data.accountNumber || "",
        bankName: data.bankName || "",
        ifsc: data.ifsc || "",
      });
    } catch (err) {
      console.error("load profile error", err);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const saveProfile = async (e) => {
    e.preventDefault();

    if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      return alert("Invalid email");
    }

    if (form.number && !/^\d{10}$/.test(form.number)) {
      return alert("Invalid phone number");
    }

    if (form.accountNumber && form.accountNumber.length < 9) {
      return alert("Invalid account number");
    }

    if (form.ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifsc)) {
      return alert("Invalid IFSC code");
    }

    try {
      const res = await API.put("/auth/profile", form);
      setProfile(res.data);
      setUser(res.data);
      setEditing(false);
      alert("Profile updated successfully!");
    } catch (err) {
      console.error("save profile error", err);
      alert("Failed to save profile");
    }
  };

  const uploadLogo = async () => {
    if (!logoFile || !profile?._id) return alert("Choose a logo and save profile first");
    try {
      const fd = new FormData();
      fd.append("companyLogo", logoFile);
      await API.post(`/auth/upload-company-logo/${profile._id}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPreviewLogo(null);
      setLogoFile(null);
      await loadProfile();
      alert("Logo uploaded successfully!");
    } catch (err) {
      console.error("logo upload error", err);
      alert("Logo upload failed");
    }
  };

  if (!profile) return <DashboardLayout><p>Loading profile...</p></DashboardLayout>;

  return (
    <DashboardLayout>
      <div className="profile-page">
        <h2>My Profile</h2>

        <div className="profile-grid">
          {/* Left: Profile Card */}
          <div className="left">
            <div className="card">
              <img
                src={previewLogo || profile.companyLogo || "/placeholder.png"}
                alt="Company Logo"
                className="logo-preview"
              />
              <h3>{profile.companyName}</h3>
              <p>{profile.email}</p>
            </div>
          </div>

          {/* Right: Info / Edit Form */}
          <div className="right">
            {!editing ? (
              <div className="card info">
                <p><strong>Name:</strong> {profile.name}</p>
                <p><strong>Email:</strong> {profile.email}</p>
                <p><strong>Number:</strong> {profile.number}</p>
                <p><strong>Address:</strong> {profile.address}</p>
                <p><strong>GST:</strong> {profile.gstNumber}</p>
                <p><strong>Account No:</strong> {profile.accountNumber}</p>
                <p><strong>Bank Name:</strong> {profile.bankName}</p>
                <p><strong>IFSC:</strong> {profile.ifsc}</p>
                <button className="btn primary" onClick={() => setEditing(true)}>Edit Profile</button>
              </div>
            ) : (
              <form className="card form" onSubmit={saveProfile}>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Name"
                  required
                />
                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                />
                <input
                  name="companyName"
                  value={form.companyName}
                  onChange={handleChange}
                  placeholder="Company Name"
                />
                <input
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  placeholder="Phone Number"
                />
                <input
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  placeholder="Address"
                />
                <input
                  name="gstNumber"
                  value={form.gstNumber}
                  onChange={handleChange}
                  placeholder="GST Number"
                />
                <input
                  name="accountNumber"
                  value={form.accountNumber}
                  onChange={handleChange}
                  placeholder="Account Number"
                />
                <input
                  name="bankName"
                  value={form.bankName}
                  onChange={handleChange}
                  placeholder="Bank Name"
                />
                <input
                  name="ifsc"
                  value={form.ifsc}
                  onChange={handleChange}
                  placeholder="IFSC"
                />
                <div className="row actions">
                  <button className="btn primary" type="submit">Save</button>
                  <button type="button" className="btn" 
                  onClick={() => {
                    setForm(profile);
                    setEditing(false)
                    }}>Cancel</button>
                </div>
              </form>
            )}

            {/* Logo Upload */}
            <div className="card">
              <h4>Company Logo</h4>
              <input
                type="file"
                accept="image/*"
                onChange={e => {
                  const file = e.target.files[0];
                  setLogoFile(file);
                  if (file) setPreviewLogo(URL.createObjectURL(file));
                }}
              />
              {previewLogo && <img src={previewLogo} alt="Preview" className="logo-preview" />}
              <button className="btn primary" onClick={uploadLogo}>Upload Logo</button>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Profile;
